var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.296 9.984V8.688C7.296 8.048 6.992 7.504 6.624 7.296L3.2 5.312C3.088 5.248 3.04 5.104 3.04 4.928V4.624C3.04 4.304 3.216 4.144 3.536 4.144H4.816C5.2 4.144 5.472 4.224 5.776 4.352L6.992 4.864L7.168 3.072L6.096 2.608C5.728 2.448 5.328 2.368 5.12 2.368H5.088V0.464H3.072V2.368H2.992C1.872 2.368 0.928 3.264 0.928 4.384V5.504C0.928 6.144 1.232 6.704 1.6 6.912L4.992 8.88C5.104 8.944 5.168 9.088 5.168 9.264V9.744C5.168 10.064 4.976 10.224 4.656 10.224H3.232C2.848 10.224 2.56 10.144 2.256 10.016L1.056 9.504L0.88 11.296L1.936 11.76C2.304 11.92 2.704 12 3.024 12H3.072V14.064H5.088V12H5.248C6.368 12 7.296 11.104 7.296 9.984Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoller);
export default __webpack_public_path__ + "static/media/doller.6d0cf1b88565aee6021d2f5e59780bdf.svg";
export { ForwardRef as ReactComponent };